import React, { useCallback } from 'react'
import { TtTrayVideo } from '@23/react'
import { getVideo } from '../../../../Video/blocs/useVideo'
import { useVideoPicker } from '../../../../Video/components/VideoPicker/VideoPicker'

// @ts-expect-error — importing js
import usePlaybackIntent from '../../../hooks/usePlaybackIntent'
import {
  setActiveCard,
  updateVideoCard,
  useTrayCard,
  useTrayCardState,
} from '../../../../firebase/hooks/useTray'
import { type PropsWithTrayItemChildren } from '../TrayItem'

interface VideoCardProps {
  id: string
}

const VideoCard = ({
  id,
  children,
}: PropsWithTrayItemChildren<VideoCardProps>) => {
  const card = useTrayCard(id)
  const cardState = useTrayCardState(id)
  const { setPlaybackPlayIntent } = usePlaybackIntent()
  const pickVideo = useVideoPicker()

  const handleCardEditing = useCallback(async () => {
    if (card?.type !== 'video') return

    const videoId = await pickVideo(card.videoId)

    if (videoId && card?.id) {
      const video = await getVideo(videoId)

      if (video.mediumDownload) {
        updateVideoCard(
          card.id,
          videoId,
          video.title,
          video.thumbnail ?? '',
          video.mediumDownload.replace('/video_medium/', '/video_1080p/')
        )
      }
    }
  }, [card, pickVideo])

  if (card?.type !== 'video') return null

  const onCardClickHandler = () => {
    setActiveCard(id)

    setPlaybackPlayIntent({
      photo_id: card.videoId,
      video_1080p_download: card.playback,
    })
  }

  return (
    <TtTrayVideo
      label={card.label}
      src={card.thumbnail}
      selected={cardState === 'active'}
      disabled={cardState === 'done'}
      onTt-click={(event) => {
        if (event.target === event.currentTarget) {
          onCardClickHandler()
        }
      }}
    >
      {children?.({
        isMedia: true,
        canEdit: true,
        onEdit: handleCardEditing,
      })}
    </TtTrayVideo>
  )
}

export default VideoCard
